module.exports = __webpack_public_path__ + "img/car_00044.24ef0d22.jpg";